import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// ACTIONS
const GET_VEHICLES_DATA =
  'luft/operational-dashboard-vehicles/GET_VEHICLES_DATA';
const GET_VEHICLES_DATA_SUCCESS =
  'luft/operational-dashboard-vehicles/GET_VEHICLES_DATA_SUCCESS';
const GET_VEHICLES_DATA_FAILURE =
  'luft/operational-dashboard-vehicles/GET_VEHICLES_DATA_FAILURE';

// REDUCER
const INITIAL_STATE = {
  isFetching: false,
  error: false,
  data: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_VEHICLES_DATA:
      return {
        ...state,
        isFetching: true,
        error: false,
      };
    case GET_VEHICLES_DATA_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
      };
    case GET_VEHICLES_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// ACTION CREATORS
const _getVehiclesData = () => ({
  type: GET_VEHICLES_DATA,
});
const _getVehiclesDataSuccess = data => ({
  type: GET_VEHICLES_DATA_SUCCESS,
  data,
});
const _getVehiclesDataFailure = error => ({
  type: GET_VEHICLES_DATA_FAILURE,
  error,
});

// THUNK ACTION CREATORS
export const getVehiclesData = searchParams => async dispatch => {
  dispatch(_getVehiclesData());
  try {
    const response = await luftGet(
      '/DashboardOperational/Vehicles',
      searchParams,
    );
    dispatch(_getVehiclesDataSuccess(response.data));
  } catch (error) {
    loggedUserRequestErrorHandler(
      dispatch,
      error,
      _getVehiclesDataFailure(error.message),
    );
  }
};
